module.exports = __webpack_public_path__ + "img/read-also-card.e81ceed4.png";